<template>
  <div>
    <div class="container bg-white" style="padding: 20px 0 0 30px;">
      <!-- 初始化时会默认调用，时间为七天内 -->
      <time-select @timeChange="timeChange" />
      <!-- <div class="f-e">
    </div> -->
      <statistical-chart ref="statisticalChart" @paramsChange="paramsChange" @exportData="exportData" />
    </div>
  </div>
</template>

<script>
import TimeSelect from '../dashboard/components/timeSelect.vue'
import StatisticalChart from './components/StatisticalChart.vue'
import moment from 'moment'
import API from '@/api'
export default {
  name: 'eventStudy',
  components: {
    TimeSelect,
    StatisticalChart
  },
  data() {
    return {
      chartData: [],
      timeValue: undefined,
      allUpcomingMatter: []
    }
  },
  mounted() {
  },
  created() {
    this.getAllUpcomingMatter()
  },
  methods: {
    // 时间筛选
    timeChange(value, firstLoad = false) {
      this.timeValue = value
      const params = {
        startTime: value[0].valueOf(),
        endTime: value[1].valueOf()
      }
      if (value[0].valueOf() === value[1].valueOf()) {
        params.startTime = moment(`${value[0].format('YYYY-MM-DD')} 00:00:00`).valueOf()
        params.endTime = moment(`${value[1].format('YYYY-MM-DD')} 23:59:59`).valueOf()
      }
      if (!firstLoad) params.selectList = this.$refs.statisticalChart.eventList
      this.getData(params, firstLoad)
    },
    getData(params, firstLoad = false) {
      if (firstLoad) {
        API.userBehaviorGet({ type: 1 }).then(res1 => {
          params.selectList = JSON.parse(res1.data)
          API.eventStudyGetData(params).then(res => {
            this.$nextTick(() => {
              this.$refs.statisticalChart.setEventList(JSON.parse(res1.data))
              this.$refs.statisticalChart.setChartData(res.data)
            })
          })
        })
      } else {
        API.eventStudyGetData(params).then(res => {
          this.$nextTick(() => {
            this.$refs.statisticalChart.setChartData(res.data)
          })
        })
      }
    },
    paramsChange(info) {
      const { selectList, isGetData } = info
      if (isGetData) {
        const params = {
          startTime: this.timeValue[0].valueOf(),
          endTime: this.timeValue[1].valueOf(),
          selectList: selectList
        }
        this.getData(params)
      }
    },
    exportData() {
      const params = {
        fileType: 2,
        taskType: 13
      }
      const condition = {
        selectList: this.$refs.statisticalChart.eventList,
        startTime: this.timeValue[0].valueOf(),
        endTime: this.timeValue[1].valueOf()
      }
      params.condition = JSON.stringify(condition)
      API.dashboardImportExportFile(params).then(() => {
        this.$message.success('操作成功，请到导入导出管理查看')
      }).catch(err => {
        this.$message.error(err.data.message)
      })
    },
   
  }
}
</script>

<style lang="scss" scoped>
.container {
  min-width: 1500px;
  
  .topBreadcrumb {
    padding-bottom: 10px;
  }
}
.task-box {
  height: 217px;
  margin-bottom: 10px;
  padding: 21px 0 0 30px;
  h2 {
    font-weight: 500;
    font-size: 20px;
    line-height: 30px;
    color: #111827;
    padding-bottom: 14px;
  }
  .matter-item {
    width: 389.89px;
    height: 118px;
    background: #ffffff;
    border: 1px solid #e5e6eb;
    box-shadow: 0px 4px 14px 6px rgba(205, 212, 221, 0.1);
    border-radius: 6px;
    margin-right: 40px;
    margin-bottom: 40px;
    padding: 26px 30px;
  }
  .type {
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    color: #747a87;
  }
  .count {
    font-weight: 500;
    font-size: 20px;
    line-height: 30px;
    color: #000000;
  }
  img {
    width: 32px;
    height: 37px;
  }
}
</style>